/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lock': {
    width: 18,
    height: 20,
    viewBox: '0 0 18 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M11.777 6.917h3.494c.985 0 1.791.806 1.791 1.791v8.959c0 .985-.806 1.791-1.791 1.791H2.729a1.797 1.797 0 01-1.792-1.791V8.708c0-.985.807-1.791 1.792-1.791h1.792V5.125A4.48 4.48 0 019 .645a4.48 4.48 0 014.48 4.48h-1.703v1.792zM6.223 5.125v1.792h5.554V5.125A2.78 2.78 0 009 2.348a2.78 2.78 0 00-2.777 2.777zM9 15.875A2.687 2.687 0 109 10.5a2.687 2.687 0 000 5.375z" _fill="#0071B3"/>'
  }
})
